import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dd3e89c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { class: "high-light" }
const _hoisted_6 = { class: "high-light" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"space\" data-v-5dd3e89c></div><p class=\"ranking\" data-v-5dd3e89c>职场数据</p><div class=\"row\" style=\"background:#E5F6F4;font-weight:500;\" data-v-5dd3e89c><div style=\"width:20%;height:50px;\" data-v-5dd3e89c>区域</div><div style=\"width:20%;height:50px;\" data-v-5dd3e89c>发包方</div><div style=\"width:30%;height:50px;word-break:break-word;\" data-v-5dd3e89c> 当日税前业务利润 </div><div style=\"width:30%;height:50px;word-break:break-word;\" class=\"percentage\" data-v-5dd3e89c> 本月累计税前业务利润 </div></div>", 3)
const _hoisted_10 = { class: "mark list" }
const _hoisted_11 = { class: "border-b" }
const _hoisted_12 = { style: { width: '20%' } }
const _hoisted_13 = { style: { width: '20%' } }
const _hoisted_14 = { style: { width: '30%' } }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { style: { width: '30%', wordBreak: 'break-word' } }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { CellGroup, Cell, Overlay, Loading, Empty } from "vant";
import { formatPercentage, numToMoney } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'CallOperator',
  setup(__props) {

const route = useRoute();
const field = ref("orderPayCount");

let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");

const visible = ref(false);
const pageData = ref<any>({});
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/call/getTotalGrossProfit",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      type: "operator",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
getPageData();

// 产品排行
const productsList = ref<any>([]);
const getProductsData = async () => {
  const res = await request({
    url: "/api/wx/call/employer-grossProfit-list",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      type: "operator",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    productsList.value = res.data;
  } else {
    // showFailToast(res.data);
  }
};
getProductsData();

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Cell), {
              title: "当日税前业务利润",
              size: "large",
              class: "bold",
              "title-style": { flex: 'inherit' }
            }, {
              value: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_unref(numToMoney)(pageData.value.todayGrossProfit)) + " (环比：", 1),
                  _createElementVNode("span", {
                    style: _normalizeStyle({ color: pageData.value.todayRate >= 0 ? 'green' : 'red' })
                  }, _toDisplayString(`${pageData.value.todayRate >= 0 ? "+" : ""}${_unref(formatPercentage)(
                      pageData.value.todayRate
                    )}`), 5),
                  _createTextVNode(") ")
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Cell), {
              title: "本月累计税前业务利润",
              size: "large",
              class: "bold",
              "title-style": { flex: 'inherit' }
            }, {
              value: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(numToMoney)(pageData.value.currMonthGrossProfit)) + " ", 1),
                  _createElementVNode("span", null, [
                    _createTextVNode("(环比："),
                    _createElementVNode("span", {
                      style: _normalizeStyle({
                      color: pageData.value.currMonthRate >= 0 ? 'green' : 'red',
                    })
                    }, _toDisplayString(`${
                        pageData.value.currMonthRate >= 0 ? "+" : ""
                      }${_unref(formatPercentage)(pageData.value.currMonthRate)}`), 5),
                    _createTextVNode(")")
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_7,
        (!productsList.value?.length)
          ? (_openBlock(), _createBlock(_unref(Empty), {
              key: 0,
              description: "暂无数据",
              "image-size": "100"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row",
              key: index
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.area), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.employer), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_unref(numToMoney)(item.todayGrossProfit)) + " ", 1),
                  _createElementVNode("span", {
                    style: _normalizeStyle({
                    color: item.todayRate >= 0 ? 'green' : 'red',
                  })
                  }, [
                    _hoisted_15,
                    _createTextVNode("(" + _toDisplayString(`${item.todayRate >= 0 ? "+" : ""}${_unref(formatPercentage)(
                      item.todayRate
                    )}`) + ")", 1)
                  ], 4)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createTextVNode(_toDisplayString(_unref(numToMoney)(item.currMonthGrossProfit)) + " ", 1),
                  _createElementVNode("span", {
                    style: _normalizeStyle({
                    color: item.currMonthRate >= 0 ? 'green' : 'red',
                  })
                  }, [
                    _hoisted_17,
                    _createTextVNode("(" + _toDisplayString(`${item.currMonthRate >= 0 ? "+" : ""}${_unref(formatPercentage)(
                      item.currMonthRate
                    )}`) + ")", 1)
                  ], 4)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})